'use client'

import { useAmplitudeProductListViewed } from '../../../hooks/use-amplitude-product-list-viewed'

export function AmplitudeProductListViewed({
  category,
  subCategory,
  categoryId,
}: {
  category: string
  subCategory?: string
  categoryId?: string
}) {
  useAmplitudeProductListViewed({ category, subCategory, categoryId })
  return null
}
